<template>
    <div class="container" id="main">
        <h1 class="title">Recipe Crafting</h1>
        <b-notification v-if="error" type="is-danger" has-icon>
            {{error}}
        </b-notification>
        <b-loading :active="loading"/>
        <div v-if="!loading && !error" class="card">
            <div class="card-content">
                <div class="media">
                    <div class="media-left">
                        <figure class="image is-48x48">
                            <img :src="recipe.itemIconUrl" alt="Item icon">
                        </figure>
                    </div>
                    <div class="media-content">
                        <p class="title is-4">{{ recipe.craftCount }} {{ recipe.itemName }}</p>
                        <p class="subtitle is-6"><gold-amount :amount="recipe.totalProfit"></gold-amount></p>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-one-quarter">
                        <p class="title is-5">Summary</p>
                        <table class="table is-narrow is-striped">
                            <tr>
                                <th>Instant sell</th>
                                <td><gold-amount :amount="recipe.postTaxTotalPrice"></gold-amount></td>
                            </tr>
                            <tr>
                                <th>Bought materials</th>
                                <td><gold-amount :amount="-recipe.totalBoughtMaterialCost"></gold-amount></td>
                            </tr>
                            <tr>
                                <th>Profit</th>
                                <td><gold-amount :amount="recipe.totalProfit"></gold-amount></td>
                            </tr>
                        </table>
                    </div>
                    <div class="column">
                        <p class="title is-5">Bought materials</p>
                        <b-table :data="recipe.boughtMaterials" :default-sort="['price', 'desc']" :striped="true" :narrowed="true">
                            <template slot-scope="props">
                                <b-table-column field="icon" label="">
                                    <img class="image is-24x24" :src="props.row.item.item.icon" alt="Item icon">
                                </b-table-column>
                                <b-table-column field="name" label="Item" sortable>
                                    {{ props.row.item.item.name }}
                                </b-table-column>
                                <b-table-column field="amount" label="Count" sortable>
                                    {{ props.row.item.count }}
                                </b-table-column>
                                <b-table-column field="total_cost" label="Cost" sortable>
                                    <gold-amount :amount="props.row.price"></gold-amount>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                    <div class="column">
                        <p class="title is-5">Crafting tree</p>
                        <div class="content" v-html="recipe.craftingTree"></div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div id="stacks" class="card-footer-item">
                    <b-table :data="recipe.soldStacks" :default-sort="['profitPerItem', 'desc']" :striped="true" :narrowed="true">
                        <template slot-scope="props">
                            <b-table-column field="icon" label="">
                                <img class="image is-24x24" :src="recipe.itemIconUrl" alt="Item icon">
                            </b-table-column>
                            <b-table-column field="recipe.itemName" label="Item" sortable>
                                {{ recipe.itemName }}
                            </b-table-column>
                            <b-table-column field="amount" label="Count" sortable>
                                {{ props.row.count }}
                            </b-table-column>
                            <b-table-column field="unitPrice" label="Unit price (pre-tax)" sortable>
                                <gold-amount :amount="props.row.preTaxUnitPrice"></gold-amount>
                            </b-table-column>
                            <b-table-column field="profitPerItem" label="Profit per item" sortable>
                                <gold-amount :amount="props.row.profitPerItem"></gold-amount>
                            </b-table-column>
                            <b-table-column field="postTaxTotalPrice" label="Total price (post-tax)" sortable>
                                <gold-amount :amount="props.row.postTaxTotalPrice"></gold-amount>
                            </b-table-column>
                            <b-table-column field="totalProfit" label="Total profit" sortable>
                                <gold-amount :amount="props.row.totalProfit"></gold-amount>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import GoldAmount from "@/components/GoldAmount.vue";
    import axios from 'axios';

    export default {
        name: 'crafting-calculator',
        components: {
            GoldAmount,
        },
        data() {
            return {
                loading: true,
                recipe: {},
                error: "",
            }
        },
        methods: {
            loadAsyncData() {
                this.loading = true;
                axios.get("/shinies/recipes/crafting", {
                    params: this.$route.query
                }).then(response =>
                {
                    this.recipe = response.data;
                    this.error = "";
                }).catch(error => {
                    this.recipe = null;
                    this.error = error;
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        mounted() {
            this.loadAsyncData();
        }
    }
</script>
